const isProd = process.env.DEPLOY_ENV === "Production";

const PRD_WEBSITE = "https://rebott.appclouddd.com";
const UAT_WEBSITE = "https://rebott-uat.appclouddd.com";

export const REBOTT_URL_WEBSITE =
  process.env.NEXT_PUBLIC_REBOTT_URL_WEBSITE ||
  (isProd ? PRD_WEBSITE : UAT_WEBSITE);
export const REBOTT_API_V2 = isProd ? "https://rebott-capi.appclouddd.com" : "https://rebott-capi-uat.appclouddd.com";
export const REBOTT_API_BASE = isProd ? "https://rebott-api.appclouddd.com/rebott" : "https://rebott-api-uat.appclouddd.com/rebott";

export const REBOTT_API_LOCATION_BASE = isProd ? "https://rebott-capi.appclouddd.com/api/LandingPageServices/rvm" : "https://rebott-capi-uat.appclouddd.com/api/LandingPageServices/rvm";


// export const REBOTT_API_CONTACT = isProd ? "https://rebott-api.appclouddd.com/rebott/contact" : "https://rebott-api-uat.appclouddd.com/rebott/contact";
export const REBOTT_API_CONTACT = isProd ? "https://rebott-capi.appclouddd.com/rebott/contact" : "https://rebott-capi-uat.appclouddd.com/api/LandingPageServices/contact";


export const REBOTT_API_TOTAL_BOTTLE = isProd ? "https://rebott-api.appclouddd.com/rebott/total-bottle" : "https://rebott-api-uat.appclouddd.com/rebott/total-bottle";
// export const REBOTT_API_DASHBOARD_SUMMARY = isProd ? "https://rebott-api.appclouddd.com/api/LandingPageServices/dashboard-summary" : "https://rebott-api-uat.appclouddd.com/api/LandingPageServices/dashboard-summary";
export const REBOTT_API_DASHBOARD_SUMMARY = isProd ? "https://rebott-capi.appclouddd.com/api/LandingPageServices/dashboard-summary" : "https://rebott-capi-uat.appclouddd.com/api/LandingPageServices/dashboard-summary";

export const REBOTT_URL_LINE_OA = isProd ? "https://lin.ee/7kGbvNE" : "https://line.me/R/ti/p/@788znpqy";
export const REBOTT_URL_LINK_PORTAL = isProd ? "https://rebott.appclouddd.com/link-portal/" : "https://rebott-uat.appclouddd.com/link-portal/";
export const REBOTT_GEC = isProd ? "https://boonrawdpdpa.gec.co.th/api/Scripts/GECBanner/gecbanner.js?=1750824799381" : "https://boonrawdpdpa.gec.co.th/api/Scripts/GECBanner/gecbanner.js?=1750824799381";

export const REBOTT_URL_MANUAL = isProd ? "https://rebott.appclouddd.com/rebott-manual/" : "https://rebott-uat.appclouddd.com/rebott-manual/";
